import * as React from 'react'
import type { ZodError } from 'zod'
import { z } from 'zod'
import { zx } from 'zodix'

import type { ActionArgs, LoaderArgs, V2_MetaFunction } from '@remix-run/node'
import { json } from '@remix-run/node'
import { Form, useActionData } from '@remix-run/react'
import {
    checkUserExistsByEmail,
} from '~/models/user.server'
import { putRequest } from "~/utils/axios";

export async function loader({ request }: LoaderArgs) {
    try {
        return json({})
    } catch (err) {
        console.log('\n forgot password page error...', err)
        return json({
            isError: true,
            error: err,
        })
    }
}

export async function action({ request }: ActionArgs) {
    try {
        const userInput = await zx.parseFormSafe(request, {
            email: z
                .string()
                .trim()
                .email({ message: 'Email is invalid' })
                .toLowerCase(),
        })

        if (!userInput.success) {
            return json({ errors: userInput.error.issues }, { status: 400 })
        }

        const { email } = userInput.data
        const existingUser = await checkUserExistsByEmail(email)
        if (!existingUser) {
            return json(
                {
                    errors: [
                        {
                            message: 'User not found, perhaps try to sign up.',
                            code: 'custom',
                            path: ['existingUser'],
                        },
                    ] as ZodError['issues'],
                },
                { status: 400 }
            )
        }
        let backendBaseUrl = process.env.BACKEND_BASE_ENDPOINT || 'https://dev.api.acmconnect.com.au'
        const ttdRes: any = await putRequest(backendBaseUrl, 'forgot-password', { email })
        if (!ttdRes?.data || !ttdRes?.data?.status) {
            throw ttdRes?.data
        }
        return { success: true };
    } catch (err: any) {
        const message = err && err.message ? err.message : 'Something went wrong please try again'
        console.log('\n forgot email Error action error:', message)
        return json(
            {
                errors: [
                    {
                        message: message,
                        code: 'custom',
                        path: ['unknownError'],
                    },
                ] as ZodError['issues'],
            },
            { status: 400 }
        )
    }
}

export const meta: V2_MetaFunction = () => [{ title: 'Forgot Password' }]

export default function LoginPage() {
    const actionData: any = useActionData<typeof action>()
    const emailRef = React.useRef<HTMLInputElement>(null)
    const [error, setError] = React.useState<any>(null)
    const [isEmailSend, setIsEmailSend] = React.useState<boolean>(false)

    React.useEffect(() => {
        try {
            if (!actionData) return;
            if (actionData?.errors) {
                const emailError = actionData?.errors.find((e: any) => e.path.includes('email'))

                const existingUserError = actionData?.errors.find((e: any) =>
                    e?.path?.includes('existingUser')
                )
                const unknowError = actionData?.errors.find((e: any) =>
                    e.path.includes('unknownError')
                )
                if (emailError || existingUserError || unknowError) {
                    emailRef.current?.focus()
                    console.log('\n error...', emailError, existingUserError, unknowError)
                    setError(emailError || existingUserError || unknowError)
                    setTimeout(() => {
                        setError(null)
                    }, 2000);
                }
            }
            if (actionData?.success) {
                setIsEmailSend(true);
            }
            console.log('\n actionData....', actionData)
        } catch (err: any) {
            console.log('\n error in actionData ...', err.message || err);
        }
    }, [actionData])

    return (
        <main className="authBody-holder py-5">
            <section className="mt-0 overflow-hidden bg-white xl:pb-0 w-full">
                <div className="container mx-auto px-4">
                    <div className="mx-auto max-w-2xl text-center">
                        <h2 className="font-heading tracking-px-n mb-[45px] text-center text-6xl font-bold leading-tight text-primary md:text-7xl">
                            Forgot Password
                        </h2>

                        {!isEmailSend ?
                            <>
                                <p className="mb-3">
                                    Please enter your email address to search for your account.
                                </p>
                                <Form method="post">
                                    <label className="mb-5 block text-left">
                                        <div className="flex space-x-2">
                                            <p className="pb-2 font-medium text-[#525252]">Email</p>
                                            <p className="font-bold text-primary">*</p>
                                        </div>
                                        <input
                                            className="w-full rounded-lg border border-primary bg-white px-4 py-3.5 font-medium text-gray-500 placeholder-gray-500 outline-none focus:ring focus:ring-green-700"
                                            ref={emailRef}
                                            id="email"
                                            required
                                            autoFocus={true}
                                            name="email"
                                            type="email"
                                            autoComplete="email"
                                            aria-invalid={
                                                error ? true : undefined
                                            }
                                            aria-describedby="email-error"
                                            placeholder="Email Address"
                                        />
                                        {error && (
                                            <div className="pt-1 text-red-700" id="email-error">
                                                {error.message}
                                            </div>
                                        )}
                                    </label>
                                    <button
                                        className="hover:shadow-4xl mb-8 rounded-xl border bg-secondary py-4  px-9 font-semibold text-white shadow-sm transition duration-200 hover:bg-lightBlue ease-in-out focus:ring focus:ring-indigo-300"
                                        type="submit"
                                    >
                                        Send Email
                                    </button>
                                </Form></> : <p className="mb-3">
                                An email to reset your password has been sent to your inbox. Please check your mailbox.
                            </p>
                        }
                    </div>
                </div>
            </section>
        </main>
    )
}
